import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from '@/components/ui/select';
import { Label } from '@/components/ui/label';
import { useClaimPipelines } from '@/hooks/use-claim-pipelines';

interface ClaimPipelineSelectProps {
    value: number | undefined;
    onChange: (pipelineId: number | undefined) => void;
    disabled?: boolean;
}

export function ClaimPipelineSelect({ value, onChange, disabled = false }: ClaimPipelineSelectProps) {
    const { pipelines, isLoading } = useClaimPipelines();
    const defaultPipeline = pipelines.find((pipeline) => pipeline.isSystemDefault) ?? pipelines[0];
    const selectedPipeline = pipelines.find((pipeline) => pipeline.id === value) ?? defaultPipeline;
    const effectiveValue = value ?? defaultPipeline?.id;

    return (
        <div className="space-y-2">
            <Label htmlFor="claim-pipeline">Workflow</Label>
            <Select
                value={effectiveValue === undefined ? undefined : String(effectiveValue)}
                onValueChange={(selectedValue) => onChange(Number(selectedValue))}
                disabled={disabled || isLoading}
            >
                <SelectTrigger id="claim-pipeline">
                    <SelectValue>
                        {isLoading ? (
                            'Loading workflows...'
                        ) : selectedPipeline ? (
                            <span className="inline-flex items-center gap-1.5">
                                <span
                                    className="h-2.5 w-2.5 rounded-full border"
                                    style={{ backgroundColor: selectedPipeline.color ?? '#94A3B8' }}
                                />
                                <span className="truncate">{selectedPipeline.name}</span>
                            </span>
                        ) : (
                            'No workflows available'
                        )}
                    </SelectValue>
                </SelectTrigger>
                <SelectContent>
                    {pipelines.map((pipeline) => (
                        <SelectItem key={pipeline.id} value={String(pipeline.id)}>
                            <span className="inline-flex items-center gap-2">
                                <span
                                    className="h-2.5 w-2.5 rounded-full border"
                                    style={{ backgroundColor: pipeline.color ?? '#94A3B8' }}
                                />
                                {pipeline.name}
                            </span>
                        </SelectItem>
                    ))}
                </SelectContent>
            </Select>
        </div>
    );
}